import { Trans, useTranslation } from 'react-i18next';
import Checklist from '@/web/components/Checklist';
import { LearningCentreModal } from '@/web/components/LearningCentreModal/LearningCentreModal';
import { Heading, IconMoneyBills, Text } from '@coverflex-tech/hypernova';
import { css } from './CreditsLearningCenter.css';

export interface ILearningCenterProps {
  onClose: () => void;
}

export const CreditsLearningCenter = ({ onClose }: ILearningCenterProps) => {
  const { t } = useTranslation();
  const bulletPoints = t('dashboard.credits.home.learning_centre.how_list', {
    returnObjects: true,
  }) as string[];
  return (
    <LearningCentreModal
      icon={<IconMoneyBills themeColor="neutral30" />}
      onClose={onClose}
      steps={[
        <div key="learning_centre_about" className={css.container}>
          <div className={css.column}>
            <Heading level={5} className={css.title}>
              {t('dashboard.credits.home.learning_centre.about_title')}
            </Heading>
            <Text>
              <Trans
                i18nKey={
                  'dashboard.credits.home.learning_centre.about_description'
                }
              />
            </Text>
          </div>
          <div className={css.column}>
            <Heading level={5} className={css.title}>
              {t('dashboard.credits.home.learning_centre.how_title')}
            </Heading>
            <Checklist points={bulletPoints} />
          </div>
        </div>,
      ]}
      title={t('dashboard.credits.home.learning_centre.title')}
    />
  );
};
